import React from "react";

const DeleteConfirmationModal = ({
  id,
  title = "Delete",
  message = "Are you sure you want to delete this item?",
  warning,
  onConfirm,
}) => {
  return (
    <div
      className="modal fade"
      id={id}
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title" id={`${id}Label`}>
              {title}
            </h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>


          <div className="modal-body">
            {message}

            {warning && (
              <>
                <br />
                <br />

                <b>
                  <span className="text-danger text-center">
                    {warning}
                  </span>
                </b>
              </>
            )}
          </div>


          <div className="modal-footer">

            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>


            <button
              type="button"
              className="btn button-primary"
              onClick={onConfirm}
              data-bs-dismiss="modal"
            >
              Confirm
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;